import { render } from "./DownloadIcon.vue?vue&type=template&id=15dc6077"
const script = {}
script.render = render

export default script